export default "__VITE_ASSET__pAkFnhXb__"